import React, { useState } from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { TEAM } from '../data/mock';
import { Search } from 'lucide-react';

const CATS = ['All','Photography','Beauty','Décor','Entertainment','Styling','Choreography','Hospitality','Transport','Content Creation'];

export default function FindTeamPage() {
  const [cat, setCat] = useState('All');
  const [q, setQ] = useState('');
  const filtered = TEAM.filter(t => (cat === 'All' || t.role.toLowerCase().includes(cat.toLowerCase().slice(0,4))) && (q === '' || t.name.toLowerCase().includes(q.toLowerCase()) || t.destinations.toLowerCase().includes(q.toLowerCase())));

  return (
    <main className="pt-32">
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>Find Your Wedding Team</SectionLabel>
        <Heading className="mt-5 font-serif max-w-3xl">Great weddings are built by <span className="italic">great people.</span></Heading>
        <p className="mt-6 max-w-2xl text-[#4a5c60] text-lg">Discover professionals selected for their craft, experience and service standards.</p>

        <div className="mt-10 flex flex-col md:flex-row gap-4 items-start md:items-center">
          <div className="relative w-full md:w-80">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#6b7c80]" />
            <input placeholder="Search by name or destination" value={q} onChange={(e)=>setQ(e.target.value)} className="w-full pl-9 pr-4 py-3 bg-white border border-[#e8e0d2] focus:border-[#c3a66d] outline-none text-sm" />
          </div>
          <div className="flex flex-wrap gap-2">{CATS.map((c) => (
            <button key={c} onClick={()=>setCat(c)} className={`px-3 py-1.5 text-xs tracking-wide border transition-colors ${cat===c ? 'bg-[#053e49] text-[#ffeabf] border-[#053e49]':'border-[#e8e0d2] text-[#053e49] hover:border-[#c3a66d]'}`}>{c}</button>
          ))}</div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {filtered.map((t) => (
            <div key={t.name} className="group bg-white border border-[#e8e0d2]">
              <div className="aspect-[4/5] overflow-hidden relative">
                <img src={t.photo} alt={t.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                <div className="absolute top-3 left-3 bg-[#053e49] text-[#ffeabf] px-2 py-1 eyebrow text-[9px]">Certified</div>
              </div>
              <div className="p-5">
                <div className="eyebrow text-[#a6894f]">{t.role}</div>
                <h3 className="font-serif text-xl text-[#053e49] mt-1">{t.name}</h3>
                <div className="text-xs text-[#6b7c80] mt-3">{t.destinations}</div>
                <div className="text-xs text-[#6b7c80]">{t.languages}</div>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (<div className="col-span-full text-center py-20 text-[#6b7c80]">No professionals match this filter yet.</div>)}
        </div>
      </section>
      <CTABanner />
    </main>
  );
}
